import { CommonPage, Content, LoadableContent, PageTitle } from "common/Grid";
import { useGetSiteIdOptionsMutation } from "store/action/options-store";
import { useEffect, useState } from "react";
import { SecondaryButton } from "common/Forms";
import { useNavigate } from "react-router-dom";
import { LuPencilLine } from "react-icons/lu";
import { TableView } from "./TableView";

export const Page = () => {

  const navigate = useNavigate();

  const [getSiteIdOptionsApi, { isLoading, isError }] = useGetSiteIdOptionsMutation();
  const [siteIdOptions, setSiteIdOptions] = useState([]);

  useEffect(() => {
    async function fetchSiteIdOptions() {
      const res = await getSiteIdOptionsApi();
      const raw = res?.data?.data ?? [];

      const formatted = raw.map(x => ({
        siteid: x?.value ?? "-",
        siteName: x?.label?.split(" - ")[1] ?? "-",
        actions: (
          <SecondaryButton title="Edit Configuration" action={() => navigate(`/edit-config?siteid=${x?.value}`)}>
            <LuPencilLine />
          </SecondaryButton>
        )
      }));
      setSiteIdOptions(formatted);
    }
    fetchSiteIdOptions();
  }, [getSiteIdOptionsApi, navigate]);

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Site Configuration" classNames={["mb-5"]} />
        {/* <ResponsiveGap right={false} left={false} classNames={["w-full flex items-center justify-end"]}>
          <PrimaryButton action={() => navigate("/add-new-site")} classNames={["min-w-[150px]"]}>
            Add New Site
          </PrimaryButton>
        </ResponsiveGap> */}
        <LoadableContent isLoading={isLoading} isError={isError}>
          <TableView feeCards={siteIdOptions} />
        </LoadableContent>
      </Content>
    </CommonPage>
  );
};
